import { useEffect } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Alert, Button, Stack } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import PageShell from '../../components/layout/PageShell';
import PageHeader from '../../components/layout/PageHeader';

/** Legacy route — sub-services are managed in Transport Hub, not Ride Category masters */
export default function TransportServiceAddWizardPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => navigate('/hubs/transport', { replace: true }), 4000);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <PageShell>
      <PageHeader
        eyebrow="Transport"
        title="Sub-Services moved to Transport Hub"
        subtitle="Ride Category wizard is replaced by dynamic sub-service flow"
      />
      <Alert severity="info" sx={{ mb: 2 }}>
        Each bookable mode (bike-ride, taxi-ride, auto-ride) is a <strong>Transport Hub sub-service</strong>.
        Configure masters per slug, fares in Zone Management, and availability schedules — not static Ride Category records.
      </Alert>
      <Stack direction="row" spacing={1}>
        <Button variant="contained" component={RouterLink} to="/hubs/transport" endIcon={<OpenInNew fontSize="small" />}>
          Go to Transport Hub
        </Button>
        <Button variant="outlined" component={RouterLink} to="/transport/services">
          View Sub-Service List
        </Button>
      </Stack>
    </PageShell>
  );
}
